import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});
const UserTypeChart = ({ title = '', users = {} }) => {
  const data = useMemo(() => {
    const fetchChartData = (users) => {
      if (users?.total) {
        return [
          Math.round((users?.admin * 100) / users.total),
          Math.round((users?.sales_management * 100) / users.total),
          Math.round((users?.sales_rep * 100) / users.total),
        ];
      } else {
        return [1];
      }
    };

    const colors = users?.total === 0 ? ['#e3e3e3'] : ['#D2638C', '#43D484', '#439AD4'];

    return {
      labels: ['Admin', 'Sales Manager', 'Sales Rep'],
      datasets: [
        {
          label: '',
          data: fetchChartData(users),
          backgroundColor: colors,
          borderColor: colors,
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 1,
        },
      ],
    };
  }, [users]);
  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1}>
          <span className={styles.headerPeriod}>Distribution</span>
          <span className={styles.headerPeriod}>In the last year</span>
        </div>
        <span className={styles.headerTitle}>{title}</span>
      </div>
      <div className={styles.bodyChart}>
        <Grid container direction="row" spacing={1} alignItems="center" justifyContent="center">
          <Grid item md={6} className={styles.chartDatasets}>
            <ul className="listUnstyled">
              <li className={styles.admin}>
                Admin - <strong>{users?.admin}</strong>
              </li>
              <li className={styles.manager}>
                Sales Manager - <strong>{users?.sales_management}</strong>
              </li>
              <li className={styles.rep}>
                Sales Rep - <strong>{users?.sales_rep}</strong>
              </li>
            </ul>
          </Grid>
          <Grid item md={6} style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}>
            <div className={styles.totalContainer}>
              <h6 className="heading1">{users?.total}</h6>
              <p className="paragraph">Total</p>
              <p className="paragraph">Users</p>
            </div>
            <Doughnut data={data} options={options(users?.total)} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default UserTypeChart;
